export type Environment = "dev" | "qa" | "uat" | "drn" | "dr" | "prod";

/**
 * Detect environment from URL hostname
 */
export function detectEnvironmentFromUrl(): Environment {
  const hostname = globalThis.location.hostname;

  console.log("Current hostname:", hostname);

  if (
    hostname.includes("dev") ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("localhost")
  ) {
    return "dev";
  } else if (hostname.includes("qa")) {
    return "qa";
  } else if (hostname.includes("uat")) {
    return "uat";
  } else if (hostname.includes("drn")) {
    return "drn";
  } else if (hostname.includes("dr")) {
    return "dr";
  } else if (hostname.includes("prod")) {
    return "prod";
  }

  // Default fallback is prod (production URLs like ubt.kp.org don't contain env keywords)
  return "prod";
}

/**
 * Get config based on detected environment
 */
export function getEnvironmentConfig() {
  const env = detectEnvironmentFromUrl();

  const configs = {
    dev: {
      env: "dev",
      clientId: "UBT-OAuth-UAT-APP1599",
      apiBaseUrl: "https://apiservice-bus-dev.kp.org/api/ds/dcaq/naiubtbff/v1r",
      authUrl: "https://fam-uat.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam-uat.kp.org/as/token.oauth2",
      revokeUrl: "https://fam-uat.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam-uat.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam-uat.kp.org/pf/JWKS",
      endSessionUrl: "https://fam-uat.kp.org/idp/startSLO.ping",
      logLevel: "DEBUG",
      kpAtlasId: "APP-1599",
    },
    qa: {
      env: "qa",
      clientId: "UBT-OAuth-UAT-APP1599",
      apiBaseUrl: "https://qa-ubtbff-bff-1.naiut.aksnp.azure.kp.org",
      authUrl: "https://fam-uat.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam-uat.kp.org/as/token.oauth2",
      revokeUrl: "https://fam-uat.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam-uat.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam-uat.kp.org/pf/JWKS",
      endSessionUrl: "https://fam-uat.kp.org/idp/startSLO.ping",
      logLevel: "ERROR",
      kpAtlasId: "APP-1599",
    },
    uat: {
      env: "uat",
      clientId: "UBT-OAuth-UAT-APP1599",
      apiBaseUrl:
        "https://apiservice-bus-uat.kp.org/api/ds/dcaq/naiubtbff/v1r",
      authUrl: "https://fam-uat.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam-uat.kp.org/as/token.oauth2",
      revokeUrl: "https://fam-uat.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam-uat.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam-uat.kp.org/pf/JWKS",
      endSessionUrl: "https://fam-uat.kp.org/idp/startSLO.ping",
      logLevel: "ERROR",
      kpAtlasId: "APP-1599",
    },
    drn: {
      env: "drn",
      clientId: "UBT-OAuth-UAT-APP1599",
      apiBaseUrl:
        "https://apiservice-bus-uat.kp.org/api/ds/dcaq/naiubtbff/v1r",
      authUrl: "https://fam-uat.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam-uat.kp.org/as/token.oauth2",
      revokeUrl: "https://fam-uat.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam-uat.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam-uat.kp.org/pf/JWKS",
      endSessionUrl: "https://fam-uat.kp.org/idp/startSLO.ping",
      logLevel: "ERROR",
      kpAtlasId: "APP-1599",
    },
    prod: {
      env: "prod",
      clientId: "UBT-OAuth-PROD-APP1599",
      apiBaseUrl: "https://apiservice-bus-01.kp.org/api/ds/dcaq/naiubtbff/v1r",
      authUrl: "https://fam.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam.kp.org/as/token.oauth2",
      revokeUrl: "https://fam.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam.kp.org/pf/JWKS",
      endSessionUrl: "https://fam.kp.org/idp/startSLO.ping",
      logLevel: "ERROR",
      kpAtlasId: "APP-1599",
    },
    dr: {
      env: "dr",
      clientId: "UBT-OAuth-PROD-APP1599",
      apiBaseUrl: "https://apiservice-bus-01.kp.org/api/ds/dcaq/naiubtbff/v1r",
      authUrl: "https://fam.kp.org/as/authorization.oauth2",
      tokenUrl: "https://fam.kp.org/as/token.oauth2",
      revokeUrl: "https://fam.kp.org/as/revoke_token.oauth2",
      userInfoUrl: "https://fam.kp.org/idp/userinfo.openid",
      jwksUrl: "https://fam.kp.org/pf/JWKS",
      endSessionUrl: "https://fam.kp.org/idp/startSLO.ping",
      logLevel: "ERROR",
      kpAtlasId: "APP-1599",
    },
  };

  console.log(`Using ${env} environment config`);
  return configs[env];
}

/**
 * Get client ID for current environment
 */
export function getClientId(): string {
  return getEnvironmentConfig().clientId;
}
